// src/stores/UploadStore.ts
import { makeAutoObservable } from "mobx";
import apiService from "../services/apiService";
import { logApiError } from "../utils/logApiError";

export class UploadStore {
  isUploading = false;
  error: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  uploadAvatar = (file: File) =>
    this._uploadFile(file, "/upload-test", "avatar");
  uploadOrgLogo = (file: File, companyId) =>
    this._uploadFile(file, "/upload-test", "org_logo", companyId);
  uploadObjectPhoto = (file: File, plantId) =>
    this._uploadFile(file, "/upload-test", "object_photo", plantId);

  private _uploadFile = async (
    file: File,
    endpoint: string,
    purpose: string,
    ID: number,
  ): Promise<string | null> => {
    console.log(purpose, "purpose");
    this.isUploading = true;
    this.error = null;

    try {
      const response = await apiService.uploadFile(endpoint, file, purpose, ID); // ← purpose передаётся

      if (response.data?.success && response.data?.url) {
        return response.data.url;
      } else {
        this.error = "Сервер не вернул URL изображения";
        return null;
      }
    } catch (err: any) {
      // ... обработка ошибок
    } finally {
      this.isUploading = false;
    }
  };

  // --- Новый метод для загрузки прошивки ---
  uploadFirmware = async (
    file: File,
    type: "ESP" | "STM" | "AC_control",
    replace: boolean = false, // <-- Параметр replace теперь используется
    product: string = "", // `ОБН.3`: изделие образа, обязательное на сервере
  ): Promise<{
    success?: boolean;
    conflict?: boolean;
    filename?: string;
    message?: string;
  } | null> => {
    this.isUploading = true;
    this.error = null;

    try {
      // Вызываем apiService.uploadFirmware с переданным параметром replace
      const response = await apiService.uploadFirmware(
        file,
        type,
        replace,
        product,
      );

      // Обрабатываем ответ
      if (response.data) {
        // Проверяем, был ли это ответ с конфликтом (status 409)
        if (response.status === 409 && response.data.conflict) {
          return { conflict: true, filename: response.data.filename };
        }
        // Проверяем успешный ответ (status 200)
        if (response.status === 200 && response.data.success) {
          return { success: true };
        }
        // Другие случаи из 200 OK (например, если сервер вдруг вернёт success: false при 200)
        return { message: response.data.message || "Неизвестная ошибка" };
      } else {
        this.error = "Сервер не вернул ожидаемый ответ";
        return null;
      }
    } catch (err: any) {
      // Этот catch сработает, если axios выбросит ошибку (например, network error, или если validateStatus не охватывает нужный статус)
      // Но благодаря validateStatus (200 || 409), 409 не должно быть в catch
      logApiError("Ошибка при загрузке прошивки:", err);
      this.error = err.message || "Ошибка при загрузке";
      return null;
    } finally {
      this.isUploading = false;
    }
  };
}

export const uploadStore = new UploadStore();
